export default [
  {
    path: '/fraud-monitor/black-list',
    name: 'black-list',
    component: () => import('@/views/pages/fraud-monitor/BlackList.vue'),
    meta: {
      pageTitle: 'Blacklist',
      hasPermission: 'VIEW_BLACKLIST',
      breadcrumb: [
        {
          text: 'Fraud Monitor',
        },
        {
          text: 'Blacklist',
          active: true,
        },
      ],
    },
  },
  {
    path: '/fraud-monitor/white-list',
    name: 'white-list',
    component: () => import('@/views/pages/fraud-monitor/WhiteList.vue'),
    meta: {
      pageTitle: 'Whitelist',
      hasPermission: 'VIEW_WHITELIST',
      breadcrumb: [
        {
          text: 'Fraud Monitor',
        },
        {
          text: 'Whitelist',
          active: true,
        },
      ],
    },
  },
  {
    path: '/fraud-monitor/transaction-rule',
    name: 'transaction-rule',
    component: () => import('@/views/pages/fraud-monitor/Rules.vue'),
    meta: {
      pageTitle: 'Transaction Rule',
      hasPermission: 'VIEW_TRANSACTION_RULE',
      breadcrumb: [
        {
          text: 'Fraud Monitor',
        },
        {
          text: 'Transaction Rule',
          active: true,
        },
      ],
    },
  },
  {
    path: '/fraud-monitor/suspicious-transaction-report',
    name: 'suspicious-transaction-report',
    component: () => import('@/views/pages/fraud-monitor/SuspiciousTransactionReport.vue'),
    meta: {
      pageTitle: 'Suspicious Transaction Report',
      hasPermission: 'VIEW_SUSPICIOUS_TRANSACTION_REPORT',
      breadcrumb: [
        {
          text: 'Fraud Monitor',
        },
        {
          text: 'Suspicious Transaction Report',
          active: true,
        },
      ],
    },
  },
  {
    path: '/fraud-monitor/sanction-screening',
    name: 'sanction-screening',
    component: () => import('@/views/pages/fraud-monitor/SanctionScreening.vue'),
    meta: {
      pageTitle: 'Sanction Screening',
      hasPermission: 'VIEW_SANCTIONED_LIST',
      breadcrumb: [
        {
          text: 'Fraud Monitor',
        },
        {
          text: 'Sanction Screening',
          active: true,
        },
      ],
    },
  },
]
